import React from 'react';
import PropTypes from 'prop-types';

const GridContext = React.createContext();

GridProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

function GridProvider (props) {
  const {children, ...rest} = props;

  const context = {
    ...rest,
  };

  return (
    <GridContext.Provider value={context}>
      {children}
    </GridContext.Provider>
  );
}

export function useGrid () {
  const context = React.useContext(GridContext);

  if (context === undefined) {
    throw new Error('useGrid must be used within a GridProvider');
  }

  return context;
}

export default GridProvider;
